<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <Sidebar></Sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="24" class="gutter-row">
            <h2>
              <a-breadcrumb>
                <a-breadcrumb-item>Data Deletion Request</a-breadcrumb-item>
              </a-breadcrumb>
            </h2>
          </a-col>
        </a-row>
        <DeletionTable />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import DeletionTable from "@/components/Sites/DataDeletionTable.vue";

export default {
  name: 'DataDeletion',
  components: {
    Sidebar,
    DeletionTable
  }
};
</script>
